/* Build Your Bathroom Shelf — pick any 3, pay the bundle price. Vanilla JS. */
(function () {
  "use strict";

  var ICON = {
    tick: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>',
    prev: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>',
    next: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>',
    chev: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>',
    trash: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 6h18M9 6v12m6-12v12M5 6l1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14"/></svg>'
  };

  // Row copy for the desktop layout. The key phrase of each title is picked out
  // in purple, the same way the page heading does "Oral Care Routine"; titles
  // come from collection metafields, so the phrase is only matched, never forced.
  var ROW_EM = { must: "Essentials", hype: "Freshness Boost", tools: "Extra Mile" };
  var ROW_DESC = {
    must: "The everyday toothpaste your routine is built on.",
    hype: "Mouthwash and whitening for fresher breath and a brighter smile.",
    tools: "Brushes, tongue cleaners and sprays that finish the job."
  };
  function rowTitle(row) {
    var label = esc(row.label), em = ROW_EM[row.id];
    var at = em ? label.lastIndexOf(em) : -1;
    return at === -1 ? label : label.slice(0, at) + "<em>" + em + "</em>" + label.slice(at + em.length);
  }

  function inr(n) { return "₹" + Number(n).toLocaleString("en-IN"); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function mount(root, data) {
    var picks = [];               // variant ids, in the order they were chosen

    // The catalogue currently holds two products with the same name and price
    // (two "Xtraaa Fresh Breath Toothpaste" entries). Showing both as separate
    // cards just looks like a bug to a shopper, so only the first is kept.
    var seen = {};
    data.items = data.items.filter(function (it) {
      var key = it.title + "|" + it.price;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });

    var byId = {};
    data.items.forEach(function (it) { byId[it.id] = it; });
    var max = data.boxCount || 3;

    /* ---------------------------------------------------------------- markup */
    // First row is on screen at load, so its images load straight away (the
    // first two at high priority); everything further down stays lazy.
    function cardHtml(it, i, firstRow) {
      var showMrp = it.mrp > it.price;
      var load = !firstRow ? ' loading="lazy"' : (i < 2 ? ' fetchpriority="high"' : '');
      return '<article class="sb-card" data-id="' + esc(it.id) + '">'
        + (it.best ? '<span class="sb-card__best">Bestseller</span>' : '')
        + '<span class="sb-card__tick">' + ICON.tick + '</span>'
        + '<img class="sb-card__img" src="' + esc(it.img) + '" alt="' + esc(it.title) + '" width="320" height="320" decoding="async"' + load + '>'
        + '<h3 class="sb-card__title">' + esc(it.title) + '</h3>'
        + (it.variant && it.variant !== "Default Title" ? '<p class="sb-card__sub">' + esc(it.variant) + '</p>' : '<p class="sb-card__sub">&nbsp;</p>')
        + '<p class="sb-card__price">' + inr(it.price) + (showMrp ? '<s>' + inr(it.mrp) + '</s>' : '') + '</p>'
        + '<button type="button" class="sb-card__btn" data-act="toggle">Add to box</button>'
        + '</article>';
    }

    // The three we recommend when someone can't decide. Only shown when all
    // three are actually in stock, so it never points at something unbuyable.
    function comboItems() {
      if (!data.combo || !data.combo.length) return [];
      var found = data.combo.map(function (h) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].handle === h) return data.items[i];
        }
        return null;
      });
      return found.indexOf(null) === -1 ? found : [];
    }

    function comboHtml() {
      var items = comboItems();
      if (!items.length) return "";
      var was = items.reduce(function (n, it) { return n + Math.max(it.mrp, it.price); }, 0);
      var saving = was - data.bundlePrice;
      // The eyebrow, price line and per-item prices are desktop-only (see CSS);
      // on phones the card keeps its compact centred layout.
      return '<section class="sb-combo"><div class="sb-combo__in">'
        + '<span class="sb-combo__eyebrow">Can\'t decide?</span>'
        + '<h2>Recommended <em>combo</em></h2>'
        + '<p class="sb-combo__why">Whitening serum and toothpaste that work as a pair, plus a year of brush heads.</p>'
        + '<p class="sb-combo__price"><strong>' + inr(data.bundlePrice) + '</strong>'
        + (saving > 0 ? '<s>' + inr(was) + '</s><span class="sb-combo__save">Save ' + inr(saving) + '</span>' : '')
        + '</p>'
        + '<div class="sb-combo__items">'
        + items.map(function (it) {
            return '<div class="sb-combo__item"><img src="' + esc(it.img) + '" alt="' + esc(it.title) + '" width="320" height="320" loading="lazy" decoding="async">'
              + '<span class="sb-combo__name">' + esc(it.title) + '</span>'
              + '<span class="sb-combo__each">' + inr(it.price) + (it.mrp > it.price ? ' <s>' + inr(it.mrp) + '</s>' : '') + '</span></div>';
          }).join('<span class="sb-combo__plus" aria-hidden="true">+</span>')
        + '</div>'
        + '<button type="button" class="sb-combo__btn" data-act="combo">'
        + '<span class="sb-combo__btn-main">Pick this combo<span class="sb-combo__btn-price"> · ' + inr(data.bundlePrice) + '</span></span>'
        + (saving > 0 ? '<span class="sb-combo__btn-sub"><s>' + inr(was) + '</s> Save ' + inr(saving) + '</span>' : '')
        + '</button>'
        + '</div></section>';
    }

    function build() {
      var html = '<div class="sb-wrap">'
        + '<h1>Build Your Perfect <em>Oral Care Routine</em></h1>'
        + '<p class="sb-lede">Pick any ' + max + ' favourites and build a routine that\'s made for you — for just <em>'
        + inr(data.bundlePrice) + '</em>.</p>'
        + '</div>';

      var any = false, step = 0;
      data.rows.forEach(function (row) {
        var items = data.items.filter(function (it) { return it.row === row.id; });
        // Pinned items lead the row in the order they were pinned; the rest keep
        // the collection's own order.
        items.sort(function (a, b) { return (a.sort == null ? 999 : a.sort) - (b.sort == null ? 999 : b.sort); });
        if (!items.length) return;
        var firstRow = !any;
        any = true;
        step++;
        // Step, description and arrows only show on desktop, where the row
        // title sits in a column to the left of a one-line carousel.
        html += '<section class="sb-row" data-row="' + esc(row.id) + '">'
          + '<div class="sb-row__head">'
          + '<span class="sb-row__step">Step ' + step + '</span>'
          + '<h2>' + rowTitle(row) + '</h2>'
          + (ROW_DESC[row.id] ? '<p class="sb-row__desc">' + ROW_DESC[row.id] + '</p>' : '')
          + '<span class="sb-row__count">' + items.length + ' option' + (items.length === 1 ? '' : 's') + '</span>'
          + '<div class="sb-row__nav">'
          + '<button type="button" class="sb-row__arrow" data-act="prev" aria-label="Previous products">' + ICON.prev + '</button>'
          + '<button type="button" class="sb-row__arrow" data-act="next" aria-label="More products">' + ICON.next + '</button>'
          + '</div></div>'
          + '<div class="sb-rail">' + items.map(function (it, i) { return cardHtml(it, i, firstRow); }).join("") + '</div>'
          + '</section>';
      });
      if (!any) {
        html += '<p class="sb-empty">Nothing is in stock in this offer right now. Please check back shortly.</p>';
      }

      html += comboHtml();

      // Bundle bar — same layout as the one on the 3-in-599 collection page
      // (snippets/buy-stepoffer-collection.liquid): message strip, picked
      // circles, "n/3 Products" with a drop-down list, total, BUY BUNDLE.
      // It sits right after the combo: fixed to the bottom on phones, and on
      // desktop sticky, so it floats until the shopper scrolls past the combo
      // and then settles in place above the footer.
      var slots = "";
      for (var i = 0; i < max; i++) {
        slots += '<button type="button" class="sb-ob__slot" data-slot="' + i + '" aria-label="Pick ' + (i + 1) + ', empty">+</button>';
      }
      html += '<div class="sb-ob" data-bar>'
        + '<p class="sb-ob__msg" data-msg></p>'
        + '<div class="sb-ob__list" data-list><ul></ul></div>'
        + '<div class="sb-ob__row">'
        + '<div class="sb-ob__slots">' + slots + '</div>'
        + '<p class="sb-ob__tip" data-tip role="status" aria-live="polite"></p>'
        + '<div class="sb-ob__info">'
        + '<p class="sb-ob__count"><span data-count>0/' + max + ' Products</span>'
        + '<button type="button" class="sb-ob__toggle" data-act="list" aria-label="Show selected products" aria-expanded="false">' + ICON.chev + '</button></p>'
        + '<p class="sb-ob__total">Total: <span data-price>' + inr(0) + '</span></p>'
        + '</div>'
        + '<button type="button" class="sb-ob__buy is-disabled" data-act="buy" aria-disabled="true">'
        + '<span class="sb-ob__loader" aria-hidden="true"></span><span>BUY BUNDLE</span></button>'
        + '</div></div>';

      html += '<p class="sb-foot">No code to type — the ' + inr(data.bundlePrice)
        + ' price is applied automatically at checkout. <a href="' + esc(data.collectionUrl) + '">See the full offer</a>.</p>';

      root.innerHTML = html;
    }

    /* ---------------------------------------------------------------- state */
    function render() {
      var full = picks.length >= max;

      root.querySelectorAll(".sb-card").forEach(function (card) {
        var picked = picks.indexOf(card.dataset.id) !== -1;
        card.classList.toggle("is-picked", picked);
        card.classList.toggle("is-full", full);
        var btn = card.querySelector(".sb-card__btn");
        btn.textContent = picked ? "Added ✓" : (full ? "Box is full" : "Add to box");
      });

      root.querySelectorAll(".sb-ob__slot").forEach(function (slot, i) {
        var id = picks[i];
        var it = id ? byId[id] : null;
        var wasFilled = slot.classList.contains("is-filled");
        slot.classList.toggle("is-filled", !!it);
        if (it) {
          slot.innerHTML = '<img src="' + esc(it.img) + '" alt="">';
          slot.setAttribute("aria-label", "Pick " + (i + 1) + ": " + it.title + ". Tap to remove.");
          if (!wasFilled) {
            slot.classList.add("just-filled");
            window.setTimeout(function () { slot.classList.remove("just-filled"); }, 320);
          }
        } else {
          slot.textContent = "+";
          slot.setAttribute("aria-label", "Pick " + (i + 1) + ", empty");
        }
      });

      var mrpTotal = picks.reduce(function (n, id) { return n + (byId[id] ? byId[id].mrp : 0); }, 0);
      var priceTotal = picks.reduce(function (n, id) { return n + (byId[id] ? byId[id].price : 0); }, 0);
      var compare = Math.max(mrpTotal, priceTotal);
      var diff = compare - data.bundlePrice;

      root.querySelector("[data-count]").textContent = picks.length + "/" + max + " Products";
      // Only strike the old price through when the box is actually cheaper —
      // otherwise it reads as a discount that isn't there.
      root.querySelector("[data-price]").innerHTML = full
        ? inr(data.bundlePrice) + (diff > 0 ? '<s>' + inr(compare) + '</s>' : '')
        : inr(compare);

      var msg = root.querySelector("[data-msg]");
      var left = max - picks.length;
      msg.classList.toggle("is-warn", full && diff <= 0);
      if (!picks.length) {
        msg.textContent = "Add " + max + " products to get the bundle at " + inr(data.bundlePrice);
      } else if (!full) {
        msg.textContent = "Add " + left + " more product" + (left > 1 ? "s" : "") + " to unlock the bundle";
      } else if (diff > 0) {
        msg.textContent = "Deal unlocked! You save " + inr(diff);
      } else {
        // Honest about it: these three cost less on their own.
        msg.textContent = "These " + max + " cost " + inr(compare) + " on their own — swap one to save more";
      }

      var buyBtn = root.querySelector("[data-act=buy]");
      buyBtn.classList.toggle("is-disabled", !full);
      buyBtn.setAttribute("aria-disabled", full ? "false" : "true");

      renderList();
    }

    function renderList() {
      root.querySelector("[data-list] ul").innerHTML = picks.map(function (id) {
        var it = byId[id];
        return '<li class="sb-ob__item"><img src="' + esc(it.img) + '" alt="">'
          + '<div class="sb-ob__item-info"><p class="sb-ob__item-name">' + esc(it.title) + '</p>'
          + '<p class="sb-ob__item-price">' + inr(it.price) + '</p></div>'
          + '<button type="button" class="sb-ob__rm" data-remove="' + esc(id) + '" aria-label="Remove ' + esc(it.title) + '">' + ICON.trash + '</button>'
          + '</li>';
      }).join("");
      if (!picks.length) setListOpen(false);
    }

    function setListOpen(open) {
      root.querySelector("[data-list]").classList.toggle("is-open", open);
      var t = root.querySelector("[data-act=list]");
      t.classList.toggle("is-open", open);
      t.setAttribute("aria-expanded", open ? "true" : "false");
    }

    var tipTimer;
    function tip(text) {
      var el = root.querySelector("[data-tip]");
      el.textContent = text;
      el.classList.add("is-shown");
      window.clearTimeout(tipTimer);
      tipTimer = window.setTimeout(function () { el.classList.remove("is-shown"); }, 2200);
    }

    function toggle(id) {
      var at = picks.indexOf(id);
      if (at !== -1) { picks.splice(at, 1); }
      else if (picks.length < max) { picks.push(id); }
      else { tip("Your box is full. Remove a product to add another."); return; }
      render();
    }

    /* ----------------------------------------------------------------- cart */
    // Same flow as BUY BUNDLE on the collection page: add the lines, then apply
    // the offer code, refresh the theme's cart, and open the cart drawer.
    function addToCart(ids) {
      var body = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || "Could not add to cart");
            return d;
          });
        })
        .then(function () {
          // The discount call rotates the cart cookie, so it must come *after*
          // the add resolves or the lines are dropped.
          if (!data.offerCode) return null;
          return fetch("/discount/" + encodeURIComponent(data.offerCode), { credentials: "same-origin" })
            .catch(function () { return null; });
        })
        .then(function () {
          // Theme helpers can throw if the drawer isn't rendered yet; never let
          // that stop the cart from opening.
          try { if (typeof window.updateCartCount === "function") return Promise.resolve(window.updateCartCount()).catch(function () {}); } catch (e) {}
        })
        .then(function () {
          try { if (typeof window.refreshSideCart === "function") window.refreshSideCart(); } catch (e) {}
          try { if (window.ECXHelper && window.ECXHelper.forceUpdateCartStatus) window.ECXHelper.forceUpdateCartStatus(); } catch (e) {}
          document.documentElement.dispatchEvent(new CustomEvent("cart:update", { bubbles: true }));
          openCart();
        });
    }

    // GoKwik side cart if present, else the theme's cart drawer, else /cart.
    function openCart() {
      var tries = 0;
      (function attempt() {
        if (typeof window.openGokwikSideCart === "function") {
          try { window.openGokwikSideCart(); return; } catch (e) {}
        }
        var headerBtn = document.querySelector(".js-header-cart-status-btn");
        if (headerBtn && window.ecxCartDrawer && typeof window.ecxCartDrawer.openDrawer === "function") {
          try { window.ecxCartDrawer.openDrawer(headerBtn); return; } catch (e) {}
        }
        if (++tries < 20) { window.setTimeout(attempt, 100); return; }
        window.location.href = "/cart";
      })();
    }

    function buy() {
      var btn = root.querySelector("[data-act=buy]");
      if (btn.classList.contains("is-busy")) return;
      if (picks.length < max) {
        var need = max - picks.length;
        tip("Please add " + need + " more product" + (need > 1 ? "s" : ""));
        return;
      }
      btn.classList.add("is-busy");
      addToCart(picks)
        .then(function () { picks = []; render(); })
        .catch(function (err) { tip(err.message || "Could not add the bundle, please try again"); })
        .then(function () { btn.classList.remove("is-busy"); });
    }

    // "Pick this combo" swaps whatever is in the box for the three combo
    // products and draws the eye to the bar — BUY BUNDLE does the checkout.
    function pickCombo() {
      var items = comboItems();
      if (!items.length) return;
      picks = items.slice(0, max).map(function (it) { return it.id; });
      render();
      var bar = root.querySelector("[data-bar]");
      bar.classList.remove("is-nudged");
      void bar.offsetWidth; // restart the pulse on repeat taps
      bar.classList.add("is-nudged");
      // Stays until the box next changes, when render() rewrites the strip.
      root.querySelector("[data-msg]").textContent = "Combo added! Now tap BUY BUNDLE";
    }

    /* --------------------------------------------------------------- events */
    root.addEventListener("click", function (e) {
      var slot = e.target.closest(".sb-ob__slot");
      if (slot) {
        var id = picks[Number(slot.dataset.slot)];
        if (id) toggle(id);
        return;
      }
      var arrow = e.target.closest("[data-act=prev], [data-act=next]");
      if (arrow) {
        var rail = arrow.closest(".sb-row").querySelector(".sb-rail");
        rail.scrollBy({ left: (arrow.dataset.act === "next" ? 1 : -1) * rail.clientWidth, behavior: "smooth" });
        return;
      }
      var rm = e.target.closest("[data-remove]");
      if (rm) { toggle(rm.dataset.remove); return; }
      if (e.target.closest("[data-act=list]")) {
        if (picks.length) setListOpen(!root.querySelector("[data-list]").classList.contains("is-open"));
        return;
      }
      var comboBtn = e.target.closest("[data-act=combo]");
      if (comboBtn) { pickCombo(); return; }
      var buyBtn = e.target.closest("[data-act=buy]");
      if (buyBtn) { buy(); return; }
      var card = e.target.closest(".sb-card");
      if (card) toggle(card.dataset.id);
    });

    /* ------------------------------------------------------------ carousels */
    // Desktop arrows: greyed out at either end, hidden when a row already fits.
    function railState(row) {
      var rail = row.querySelector(".sb-rail");
      var room = rail.scrollWidth - rail.clientWidth;
      row.classList.toggle("is-static", room <= 2);
      row.querySelector("[data-act=prev]").disabled = rail.scrollLeft <= 2;
      row.querySelector("[data-act=next]").disabled = rail.scrollLeft >= room - 2;
    }
    function railsState() { root.querySelectorAll(".sb-row").forEach(railState); }

    build();
    render();

    root.querySelectorAll(".sb-row").forEach(function (row) {
      row.querySelector(".sb-rail").addEventListener("scroll", function () { railState(row); }, { passive: true });
    });
    window.addEventListener("resize", railsState);
    // The script is async, so the stylesheet may not have applied yet; check
    // again once the page has finished loading.
    window.addEventListener("load", railsState);
    railsState();
  }

  function boot() {
    document.querySelectorAll("[data-shelf-builder]").forEach(function (wrap) {
      if (wrap.dataset.sbMounted) return;
      wrap.dataset.sbMounted = "1";
      var script = wrap.querySelector("script[data-shelf-data]");
      var root = wrap.querySelector(".sb-root");
      if (!script || !root) return;
      var data;
      try { data = JSON.parse(script.textContent); } catch (e) { return; }
      if (!data.items || !data.items.length) {
        root.innerHTML = '<p class="sb-empty">Nothing is in stock in this offer right now. Please check back shortly.</p>';
        return;
      }
      mount(root, data);
    });
  }

  window.ShelfBuilder = { mount: mount, boot: boot };
  // Loaded async right after the section markup, so the shelf is already in
  // the DOM: build it now rather than waiting for the rest of the page.
  // The DOMContentLoaded pass is a safety net; boot() skips mounted shelves.
  boot();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
